import { GetterTree } from "vuex";
import { IEmployeeGradeState } from "../types";
import { StoreState } from "@/store/type";
import { IEmployeeGrade } from "@/core/interfaces/employeeGrade.interface";

const getters: GetterTree<IEmployeeGradeState, StoreState> = {
  employeeGrades: (state): IEmployeeGrade[] => state.employeeGrades,
  isFetchingEmployeeGrades: (state): boolean => state.isFetchingEmployeeGrades,
  employeeGradeActionLoading: (state): boolean =>
    state.employeeGradeActionLoading,
};

export default getters;
